import { render, staticRenderFns } from "./actor-search.vue?vue&type=template&id=a36e75da&scoped=true&"
import script from "./actor-search.vue?vue&type=script&lang=ts&"
export * from "./actor-search.vue?vue&type=script&lang=ts&"
import style0 from "./actor-search.vue?vue&type=style&index=0&id=a36e75da&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36e75da",
  null
  
)

export default component.exports